/*
 * @Description: 个体
 * @Date: 2020-10-14 15:58:13
 * @LastEditors: Please set LastEditors
 */

import { agentManager } from '@/api/ajax';
import fields from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';

let downloadName = {
  name: '名单下载',
  icon: '',
  type: 'warning',
  async fn(app, table) {
    let {
      userName = '',
      userEnterpriseName = '',
      phone = '',
      status = ''
    } = table.searchQuery;
    table.$downloadFile(
      `${agentManager.exportAgentList(
        {},
        true
      )}?allianceUserType=2&userName=${userName}&userEnterpriseName=${userEnterpriseName}&phone=${phone}&stauts=${status}&taxCollectionPattern=5&userType=2`,
      true
    );
  }
};

let example = new TableRenderClass({ fields, search });

let part = example.createPart({
  name: '个体',
  search: ['operator', 'userEnterpriseName', 'phone'],
  list: agentManager.agentList,
  defaultQueryHotfix: { userType: 2, taxCollectionPattern: 5 },
  requestNow: true,
  fields: [
    'index',
    'operator',
    'enterpriseName',
    // 'occupationAuthStatus',// 所有园区个体去掉职业认证
    'phone',
    'realNameStatus',
    'createDt',
    'historyProject',
    'taskSumSurplus',
    'passingTaskSumPlatform',
    'passTaskSumPlatform',
    'passingTaskSum',
    'noFinishTaskSum',
    'userAmount',
    'prePurchaseProsces',
    'projectSet'
  ],
  moreBtnArr: [downloadName]
});

export default part;
